<template>
  <div>
    <div
      v-if="showButtonStart == true"
      class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-3 items-center bg-white w-full rounded-lg shadow" style="background: linear-gradient(90deg, #a8c5f000 0%, #9bc3f9e6 100%);"
    >


        <div class="flex justify-center">
          <img
            v-if="showButtonStart == true"
            src="../../assets/Confirmation.svg"
            alt="Image"
            class="img-fluid"
            width="40%"
          />
        </div>
        <div class="flex justify-center">
          <div
            :class="
              showButtonStart == true
                ? 'flex justify-center w-1/3 mt-1 pt-1 space-x-2'
                : 'flex justify-center w-1/3 mt-1  pt-1 space-x-2'
            "
          >
            <div class="flex flex-col">
              <div class="mt-1 flex justify-center wrap-1">
                <button :class="loadinggetorder?'noselect':''" class="button-2"
                  v-if="showButtonStart == true"
                  @click="startConfirmation"
                  :disabled="loadinggetorder"><loading :active.sync="loadinggetorder" :is-full-page="fullPage"></loading>
                  <span v-if="!vShow"> Start </span>

                  <span v-else> Continue </span>
                  <svg class="inline ml-4 w-6 stroke-current text-white stroke-2 align-sub" width="66px" height="25px" viewBox="0 0 66 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path class="one" d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                      <path class="two" d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z" fill="#FFFFFF"></path>
                      <path class="three" d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z" fill="#FFFFFF"></path>
                    </g>
                  </svg>
                 
                </button>
                
              </div>
            </div>
          </div>
        </div>

    </div>

    <!-- _____________________________________________________ 1 page Confirmation _____________________ -->
    <div v-if="order._id && showButtonStart == false" class="font-sans bg-grey-lighter flex flex-col min-h-screen w-full bg-imgg relative">
      <!-- _______________________________________________________Section chrono && confirmation ___________________________________ -->
        <div class="container mx-auto px-40 py-4 pt-6">
            <!--Conter -->
            <div id="gettingValuesExample">
              <div class="flip-clock">
                  <span class="flip-clock__piece flip">
                      <span class="flip-clock__card flip-card">
                        <b class="flip-card__top hours">0</b>
                      </span>
                    <span class="flip-clock__slot">Hours</span>
                  </span>
                  <span class="flip-clock__piece flip">
                      <span class="flip-clock__card flip-card">
                        <b class="flip-card__top minutes">0</b>
                      </span>
                    <span class="flip-clock__slot">minutes</span>
                  </span>    
                  <span class="flip-clock__piece flip">
                      <span class="flip-clock__card flip-card">
                        <b class="flip-card__top seconds">0</b>
                      </span>
                    <span class="flip-clock__slot">seconds</span>
                  </span>        
              </div>  
            </div>
       
        </div>
      <!-- _____________________________________________End section chrono && conformation____________________________ -->

      <!-- ______________________________________________ Debut Section detail order  ___________________________________ -->

      <div class="flex-grow container mx-auto px-4 pb-8 z-1">
        <!-- <div class="w-full">
          <div class="card-2">
                <div class="card-header-1">
                    <div class="d-flex">
                        <h5 class="card-title flex-grow-1 mb-0"><svg class="inline-block fill-current mdi mdi-truck-fast-outline align-middle me-1 text-muted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z"/></svg>Double orders</h5>
                        <div class="flex-shrink-0">({{dataDouble.length}})</div>
                    </div>
                </div>
                <div class="card-body-2">
                    <div class="text-center">
                      <svg class="inline-block fill-current mdi mdi-truck-fast-outline align-middle me-1 text-black" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24"><path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z"/></svg>
                        <h5 class="fs-16 mt-2">
                          <span v-if="loadingDouble">
                            Checking ...   <div class="facebook-spinner">
                              <div class="spinner-block block-1"></div>
                              <div class="spinner-block block-2"></div>
                              <div class="spinner-block block-3"></div>
                            </div>
                          </span>
                          <span v-else>
                            Number of order doubled by this phone ({{dataDouble.length}}) <span v-if="dataDouble.length>0"><svg @click="$vm2.open('ModalDouble')" class="cursor-pointer  inline-block fill-current mdi mdi-truck-fast-outline align-middle me-1 text-black"  width="24" height="24"   clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.998 5c-4.078 0-7.742 3.093-9.853 6.483-.096.159-.145.338-.145.517s.048.358.144.517c2.112 3.39 5.776 6.483 9.854 6.483 4.143 0 7.796-3.09 9.864-6.493.092-.156.138-.332.138-.507s-.046-.351-.138-.507c-2.068-3.403-5.721-6.493-9.864-6.493zm.002 3c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4zm0 1.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z" fill-rule="nonzero"/></svg></span>
                          </span>
                        </h5>
                        <p class="phone mb-0">Phone number: {{order.customer.phone}}</p>
                    </div>
                </div>
            </div>
        </div> -->
        <div
          class="bg-white border-t border-b sm:border-l sm:border-r sm:rounded shadow"
        >
          <div class="border-b p-4">
            <div class="flex justify-between">
              <div class="flex justify-between ">
                <h3
                  class="text-black dark:text-white text-base sm:text-xl lg:text-base xl:text-xl font-semibold truncate"
                >
                  Detail Order
                </h3>
              </div>
              <!--<div class="flex text-sm py-1">
                <div class="grid grid-cols-3 gap-2">
                  <button
                    v-if="edit"
                    class="material-icons flex items-center border hover:text-white hover:bg-pink-600 border-pink-600 text-pink-600 focus:outline-none max-w-max shadow-sm hover:shadow-lg rounded-full w-12 h-12"
                    v-on:click="activateInEditMode"
                  >
                    edit
                  </button>
                  <button
                    v-if="!edit"
                    class="material-icons flex items-center border hover:text-white hover:bg-yellow-600 border-yellow-600 text-yellow-600 focus:outline-none max-w-max shadow-sm hover:shadow-lg rounded-full w-12 h-12"
                    v-on:click="updateData(order)"
                  >
                    done
                  </button>
                  <button
                    v-if="!edit"
                    class="uppercase p-2 flex items-center border focus:outline-none hover:text-white hover:bg-red-600 border-red-600 text-red-600 max-w-max shadow-sm hover:shadow-lg rounded-full w-12 h-12"
                    v-on:click="desactivateInResetMode"
                  >
                    <svg
                      width="32"
                      height="32"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 32 32"
                      style="transform: rotate(360deg)"
                    >
                      <path d="M12 12h2v12h-2z" fill="currentColor"></path>
                      <path d="M18 12h2v12h-2z" fill="currentColor"></path>
                      <path
                        d="M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20z"
                        fill="currentColor"
                      ></path>
                      <path d="M12 2h8v2h-8z" fill="currentColor"></path>
                    </svg>
                  </button>
                </div>
              </div>-->
            </div>
          </div>

          <div class="flex md:flex-row flex-col  m-auto my-4 mx-4">
            <div class="md:w-1/4 p-4 flex justify-center items-center bg-gray-200 mx-2 rounded bg-blue-box">
              <div class="w-16 h-16 p-2">
                <i class="material-icons icon-call">bookmark_border</i> 
              </div>
              <div class="ml-2">
                <div class="text-2xl uppercase leading-8">Order ID</div>
                <div>{{'#'+$f.getIdbySplit(order.id)}}</div>
              </div>
            </div>
            <div class="md:w-1/4 p-4 flex justify-center items-center bg-gray-200 mx-2 rounded bg-blue-box">
              <div class="w-16 h-16 p-2">
                <i class="material-icons icon-call">date_range</i> 
              </div>
              <div class="ml-2">
                <div class="text-2xl uppercase leading-8">Order date</div>
                <div>{{ order.date }}</div>
              </div>
            </div>
             <div class="md:w-1/4 p-4 flex justify-center items-center bg-gray-200 mx-2 rounded bg-blue-box">
              <div class="w-16 h-16 p-2">
                <i class="material-icons icon-call">contacts</i> 
              </div>
              <div class="ml-2">
                <div class="text-2xl uppercase leading-8">Seller</div>
                <div v-if="order && order.seller">{{ order.seller.fullName }}</div>
              </div>
            </div>
            <div class="md:w-1/4 p-4 flex justify-center items-center bg-gray-200 mx-2 rounded bg-blue-box">
              <div class="w-16 h-16 p-2">
                <i class="material-icons icon-call">local_grocery_store</i> 
              </div>
              <div class="ml-2">
                <div class="text-2xl uppercase leading-8">Store</div>
                <div>{{ order.source }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ________________________________________________End Detail Order ________________________ -->

        <div class="flex flex-wrap -mx-4 py-4 mb-6">
          <div class="w-full mb-6 lg:mb-0 lg:w-3/5 px-4 flex flex-col card-1">
            <div
              class="flex-grow flex flex-col bg-white border-t border-b sm:rounded sm:border shadow overflow-hidden card-body-1"
            >
              <div class="flex justify-between items-center p-4">
                <div class="flex justify-between -mb-px">
                  <h3
                    class="text-black dark:text-white text-base sm:text-xl lg:text-base xl:text-xl font-semibold truncate"
                  >
                    Order Products 
                  </h3>
                </div>
                <svg @click="EditOrder('open')" class="ml-auto feather cursor-pointer align-sub feather-file-text inline-block ml-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.424 12.282l4.402 4.399-5.826 1.319 1.424-5.718zm15.576-6.748l-9.689 9.804-4.536-4.536 9.689-9.802 4.536 4.534zm-6 8.916v6.55h-16v-12h6.743l1.978-2h-10.721v16h20v-10.573l-2 2.023z"/></svg>
              </div>

              <div class="antialiased font-san">
                <div class="container mx-auto">
                  <div class="overflow-x-auto">
                    <div
                      class="inline-block min-w-full rounded-lg overflow-hidden"
                    >
                      <table class="min-w-full leading-normal relative">
                        <loading :active.sync="loadingeditOrder" :is-full-page="fullPage"></loading>
                        <thead>
                          <tr class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                            <th
                              class="py-2 px-2 text-left"
                            >
                              Product
                            </th>
                            <th
                              class="py-2 px-2 text-left"
                            >
                              Quantity
                            </th>
                            <th
                              class="py-2 px-2 text-left"
                            >
                              Unit Price
                            </th>
                            <th
                              class="py-2 px-2 text-center"
                            >
                            Page produit
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(it, indx) in order.details"
                          :key="it._id"
                        >
                          <tr class="border-b border-gray-200 hover:bg-gray-100" :class="indx % 2 == 0 ? 'bg-gray-50' : ''">
                            <td
                              class="py-2 px-2 text-left"
                            >
                              <div class="flex items-center">
                                <div class="flex-shrink-0 w-10 h-10">
                                  <img
                                    alt="..."
                                    :src="it.product.picture||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'"
                                    class="h-10 w-10 rounded-md mx-auto"
                                  />
                                </div>
                                <div class="ml-3">
                                  <div>
                                    {{ it.product.name }}
                                    <p class="text-sm font-light">
                                      Unit Price : {{ it.unitPrice }} {{idWharhouse.currency}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td
                              class="py-2 px-2 text-left"
                            >
                              <p class="text-gray-900 whitespace-no-wrap">
                                {{ it.quantity }}
                              </p>
                            </td>
                            <td
                              class="py-2 px-2 text-left"
                            >
                              <p class="text-gray-900 whitespace-no-wrap">
                                {{ it.unitPrice }} <sup>{{idWharhouse.currency}}</sup>
                              </p>
                            </td>
                            <td
                              class="py-2 px-2 text-center "
                            >

                          
                              <a v-if="it.product.verificationLink && validURL(it.product.verificationLink)" :href="it.product.verificationLink" target="_blank" class="no-underline relative text-blue-600"><svg style="display: inherit;" class="fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 17c2.269-9.881 11-11.667 11-11.667v-3.333l7 6.637-7 6.696v-3.333s-6.17-.171-11 5zm12 .145v2.855h-16v-12h6.598c.768-.787 1.561-1.449 2.339-2h-10.937v16h20v-6.769l-2 1.914z"/></svg></a>
                               <button v-else type="button" class="text-white bg-yellow-800 hover:bg-yellow-900 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-xs px-3 py-1.5 mr-2 text-center inline-flex items-center dark:bg-yellow-300 dark:text-gray-800 dark:hover:bg-yellow-400 dark:focus:ring-yellow-800">
                                  Non défini
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div
                  class="px-5 py-5 bg-white flex flex-col xs:flex-row items-center xs:justify-between"
                >
                  <div class="inline-flex mt-2 xs:mt-0">
                    <span class="font-bold text-green-600 p-1">
                      Total Price :</span
                    >
                    <span class="rounded-full ml-1 p-1 bg-green-100 text-green-600">
                      <span
                        class="justify-center text-center p-1 w-auto rounded-full"
                      >
                        {{ order.totalPrice }} <sup>{{idWharhouse.currency}}</sup>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- __________________________________________________________End Product Order __________________________________________ -->
          <!-- __________________________________________________________Debut Customer Information ________________________________ -->

          <div class="w-full lg:w-2/5 px-4 card-1">
            <div class="bg-white border-t border-b sm:rounded sm:border shadow card-body-1">
              <div class="border-b">
                <div class="flex justify-between -mb-px">
                  <h3
                    class="text-black p-4 dark:text-white text-base sm:text-xl lg:text-base xl:text-xl font-semibold truncate"
                  >
                    Customer Information
                  </h3>
                </div>
              </div>
              <div>
                <div class="text-center px-6 py-4">
                  <div class="relative">
                    <div
                      class="icon bg-blue-600 text-white w-6 h-6 absolute flex items-center justify-center p-5"
                      style="left: -40px"
                    >
                      <i class="fal fa-phone-volume fa-fw text-2xl">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          class="fill-current h-6 w-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                          />
                        </svg>
                      </i>
                    </div>
                    <h3 class="text-2xl text-gray-900 font-semibold pb-6">
                      Let's call Customer !
                    </h3>
                    <div class="grid lg:grid-cols-2 gap-6">
                      <!-- ******************************** FULL Name && Address *********************************** -->
                      <div
                        class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                        :class="
                          style
                            ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                            : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                        "
                      >
                        <div
                          class="-mt-4 absolute tracking-wider px-1 uppercase text-xs"
                        >
                          <p>
                            <label
                              class="capitalize bg-white text-gray-600 px-1"
                              >Full Name *</label
                            >
                          </p>
                        </div>
                        <p>
                          <input
                            id="name"
                            autocomplete="false"
                            tabindex="0"
                            type="text"
                            disabled
                            placeholder="full Name"
                            v-model="order.customer.fullName"
                            :class="
                              style
                                ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                                : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                            "
                          />
                        </p>
                      </div>
                      <div
                        class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                        :class="
                          style
                            ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                            : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                        "
                      >
                        <div
                          class="-mt-4 absolute tracking-wider px-1 uppercase text-xs"
                        >
                          <p>
                            <label
                              for="phone"
                              class="capitalize bg-white text-gray-600 px-1"
                              >Phone *</label
                            >
                          </p>
                        </div>
                        <p>
                          <input
                            autocomplete="false"
                            tabindex="0"
                            type="tel"
                            disabled
                            v-model="order.customer.phone"
                            :class="
                              style
                                ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                                : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                            "
                          />
                        </p>
                      </div>
                      <div
                        class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                        :class="
                          style
                            ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                            : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                        "
                      >
                        <div
                          class="-mt-4 absolute tracking-wider px-1 uppercase text-xs"
                        >
                          <p>
                            <label
                              for="address"
                              class="capitalize bg-white text-gray-600 px-1"
                              >Adress *</label
                            >
                          </p>
                        </div>
                        <p>
                          <textarea
                            autocomplete="false"
                           
                            type="text"
                            disabled
                            placeholder="Address"
                            v-model="order.customer.address"
                            :class="
                              style
                                ? 'py-1 px-1  text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                                : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                            "
                          />
                        </p>
                      </div>
                      <!-- *************************************************END FULL NAME && Address ********************************-->
                      <!-- *************************************************Debut section Phone ********************************-->
                    
            
                      
                  <!--    <div
                        class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                        :class="
                          style
                            ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                            : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                        "
                      >
                        <div
                          class="-mt-4 absolute tracking-wider px-1 uppercase text-xs"
                        >
                          <p>
                            <label
                              for="password"
                              class="capitalize bg-white text-gray-600 px-1"
                              >Date shipping *</label
                            >
                          </p>
                        </div>
                        <p>
                          <input
                            type="date"
                            placeholder="Telephone"
                            disabled
                            v-model="shipping.date"
                            :class="
                              style
                                ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                                : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                            "
                          />
                        </p>
                      </div>-->
                      <!-- *************************************************END section Phone ********************************-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- __________________________________________________________End Customer __________________________________________ -->
        </div>
        <!-- ______________________________________________________________Debut section Button ____________________________ -->

        <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-4 p-4">
          <div v-if="checkOutOfstock.action && checkOutOfstock.type=='outofstock'" class="flex p-4 mb-4 text-sm text-yellow-700 bg-yellow-300 rounded-lg" role="alert">
            <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            <span class="sr-only">Info</span>
            <div>
              <span class="font-medium">{{checkOutOfstock.message}}</span>
                <ul class="mt-1.5 ml-4 text-yellow-700 list-disc list-inside">
                  <li>Instock: {{checkOutOfstock.stock}}</li>
              </ul>
            </div>
          </div>
         
          
          <div class="flex justify-center w-full space-x-2">
            <button v-if="checkOutOfstock.action && checkOutOfstock.type=='outofstock'" 
              @click="skipOrder(order)"
              class="w-1/6 p-2 rounded bg-orange-600 hover:bg-orange-500 text-white font-semibold focus:outline-none relative loidingconfirm" :class="loading?'noselect':''"><loading :active.sync="loading" :is-full-page="fullPage"></loading>
            
              Skip
            </button>
            <button @click="$vm2.open('modal-confirm')"
            
              class="w-1/6 p-3 rounded bg-green-600 hover:bg-green-500 text-white font-semibold focus:outline-none"
            >
              Confirm
            </button>
            <button
              @click="$vm2.open('myModalUnrached')"
              class="w-1/6 p-3 rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"
            >
              Unreached
            </button>
            <button @click="$vm2.open('myModalRemonded')"
              class="w-1/6 p-3 rounded bg-yellow-600 hover:bg-yellow-500 text-white font-semibold focus:outline-none"
            >
            A rapeller
            </button>
            <button @click="OrangeOrderStatus(order,'En attente de dépot')"
                class="w-1/6 p-2 rounded bg-depot text-white font-semibold focus:outline-none"
              >
              En attente de dépot
              </button>
            <button
              
              @click="$vm2.open('myModalCancel')"
              class="w-1/6 p-2 rounded bg-red-600 hover:bg-red-500 text-white font-semibold focus:outline-none"
            >
              Cancelled
            </button>

            <button @click="OrangeOrderStatus(order,'wrong number')"
                class="w-1/6 p-2 rounded bg-gray-600 hover:bg-yellow-500 text-white font-semibold focus:outline-none"
              >
              Wrong number
            </button>
           
          </div>
        </div>
        <!-- _______________________________________________Fin ______________________________ -->
        <!-- ____________________________________Debut section PopUp Confirmation _________________ -->
        <vue-modal-2 name="modal-confirm" :headerOptions="{title: 'Confirmation Order'}" :noFooter="true" modalSize="lg">
           <div>
              <div class="p-4 pt-0 relative">
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                  <div>
                      <div class="flex flex-col md:flex-row">
                          <div class="w-full mx-2 flex-1 svelte-1l8159u">
                              <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Shipping Date</label>                 
                              <!-- <datetime-v2  v-model="shipping.date" placeholder="Shipping Date ..." input-class="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" ></datetime-v2>  -->
                             <div class="shippDate shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                                <date-picker v-model="shipping.date" format="YYYY-MM-DD" type="date" placeholder="Shipping Date ..."></date-picker>
                             </div>
                             
                               <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Zone</label>
                             <div class="shadow bg-white mt-0 my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                  <v-select label="name" placeholder="Zone ...."  @search="serchZones($event,'zone')" v-model="shipping.zone" :options="zones"></v-select>
                             </div>
                          </div>
                          <div class="w-full mx-2 flex-1 svelte-1l8159u">
                              <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Phone 2</label>
                             <input type="tel"  placeholder="Telephone" v-model="order.customer.shippingPhone" class="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"> 
                           
                             
                           <!--   <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Courier</label>
                              <div class="shadow bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                  <v-select label="email" v-model="shipping.courrier" :options="courier"></v-select>
                             </div>-->
                    
                          </div>
                      </div>
                  <div class="w-full mx-2 flex-1">
                    <div class="mr-5">
                      <label for="shipp-add" class="font-bold h-6 text-gray-600 text-xs leading-8 uppercase"> shipping Address</label>
                      <textarea id="shipp-add" v-model="order.customer.shippingAddress"  cols="10" rows="3" placeholder="Shipping Address.." class="my-2 mt-0 p-1 shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea> 
                    </div>   
                  </div>    
                  <div class="w-full mx-2 flex-1">
                      <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Add Comment</label>
                    <div class="mr-5">
                                  <textarea
                      id="commentConfirmation"
                      cols="10"
                      rows="3"
                      placeholder="Comment ..."
                      v-model="order.comment"
                      class="my-2 mt-0 p-1 shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      ></textarea>
                    </div>
                  </div>
                  </div>
                  <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="ConfirmOrderStatus(order)" class="w-1/6 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none">Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('modal-confirm')" class="w-1/6 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
              </div>
          </div>
        </vue-modal-2>
        <!-- ___________________________________________________________Debut section PopUp _________________ -->

        <!-- ____________________________________Debut section PopUp Cancelled ___---------______________ -->
        <vue-modal-2 name="myModalCancel" :headerOptions="{title: 'Cancelation Order'}" :noFooter="true" modalSize="lg">
             <div class="flex flex-col w-full h-auto">
            <!-- Header -->
          
            <!-- Modal Content-->
            <div
              class="flex w-full relative h-auto justify-center items-center rounded text-center text-gray-500"
            >
             <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <div class="w-full bg-white px-6 pb-2  relative">
                <textarea
                  style="border-color: #a7adb3;border-width: 2px;"
                  id="commentConfir"
                  cols="10"
                  rows="3"
                  placeholder="Reason for cancellation"
                  v-model="motifAnnulation"
                  class="border p-2 mt-3 w-full focus:outline-none hover:border-blue-600"
                ></textarea>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="cancelOrder(order)" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Cancel Order</button>
                          <button :disabled="loading"  @click="CloseModal('myModalCancel')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>

              </div>
            </div>
            <!-- End of Modal Content-->
          </div>
        </vue-modal-2>


        <vue-modal-2 name="myModalRemonded" :headerOptions="{title: 'A Rapeller order'}" :noFooter="true" modalSize="lg">
           <div class="relative flex flex-col w-full h-auto">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-8 pb-2 flex flex-col">
              <label class="block text-grey-darker text-sm font-bold mb-2" for="dateremind">A Rapeller date</label>
             <!-- <datetime-v2 type="datetime" v-model="remindDate"
               placeholder="Remind date" input-class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" ></datetime-v2> -->
            <div class="shippDate shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                 <date-picker v-model="remindDate" format="YYYY-MM-DD hh:mm" type="datetime" placeholder="A Rapeller Date ..."></date-picker>
            </div>
              <div class="my-4">
                <label class="block text-grey-darker text-sm font-bold" for="content">Message</label>
                  <textarea
                    id="content"
                    cols="10"
                    rows="3"
                    placeholder="Message ..."
                    v-model="contentRemend"
                    class="focus:outline-none shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3"
                  ></textarea>
              </div>
             
            <div class="flex p-2">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="RemindOrder(order)" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('myModalRemonded')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
            </div>
            </div>
            <!-- End of Modal Content-->
          </div>
        </vue-modal-2>
       
          <vue-modal-2 name="myModalUnrached" :headerOptions="{title: 'Unreached Order'}" :noFooter="true" modalSize="lg">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-8  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <div class="my-6 mt-4">
                  <div class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1"> Reason unreached
                            <span :class="$colors.required">*</span></label>
                          </p>
                      </div>    
                      <p>
                          <v-select  v-model="motifUnrached" :options="commentsUnrach"></v-select>
                      </p>     
                  </div> 
                </div>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="UnreachedOrder(order)" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('myModalUnrached')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>

         <vue-modal-2 name="myModalDepot" :headerOptions="{title: 'En attente de dépôt'}" :noFooter="true" modalSize="md">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-2  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <p class="font-bold text-center">Etes-vous sûr de changer la commande en En attente de dépôt ?</p>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="OrangeOrderStatus(order,'En attente de dépot')" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('myModalDepot')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>

            <!--Edit order-->
            <vue-modal-2 name="EditOrder" :headerOptions="{title: `Edit order`}" :noFooter="true" modalSize="lg">
                <div class="rounded-lg mb-14">
                    <div class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative">
                       
                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                        <div  style="overflow-x: auto;">
                            
                             <div class="w-full data-ss">
                                <div class="header-1">
                                    <div class="content border border-gray-700 border-dashed rounded min-w-125px py-3 px-4 mb-3">
                                        <span class="title">Orders details</span>
                                        <div class="content-1">TotalPrice: {{TotalPrice()}} <sup>{{idWharhouse.currency}}</sup></div>
                                   </div>
                                </div>
                                <div class="header-table th-header">
                                    <div class="w-1/2"><div class="title">Product name</div></div>
                                    <div class="x8yj6t55"><div class="title">Quantity</div></div>
                                    <div class="x8yj6t55"><div class="title">Unit Price</div></div>
                                    <div class="x8yj6t5"><div class="title">Total</div></div>
                                    <div class="x8yj6t5"><div class="title">Action</div></div>
                                </div>
                                <div v-for="(item, index) in order.details" :key="index" class="header-table">
                                    <div class="w-1/2"><div class="title title-1">{{item.product.name}}</div></div>
                                    <div class="x8yj6t55"><div class="title title-1 justify-center">
                                      <div class="flex space-x-6">
                                          <button :class="$colors.textPrimary" class="bg-blue-500 rounded-md w-6 h-6 flex items-center focus:outline-none" @click="addQuantity(index)"><span class="font-bold text-2xl text-white"><i class="material-icons mt-2">add</i></span></button>
                                          <span :class="$colors.textPrimary" class="text-gray-700 text-sm h-6 flex items-center quant focus:outline-none"><input class="focus:outline-none w-12 text-center" type="text" v-model="item.quantity"/></span>
                                          <button :class="$colors.textPrimary" @click="removeQuantity(index)" class="bg-blue-500 quant rounded-md w-6 h-6 text-white flex items-center focus:outline-none"><span class="font-bold text-2xl text-white mt-1"><i class="material-icons">remove</i></span></button>
                                      </div>
                                      <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                                    </div></div>
                                    <div class="x8yj6t55"><div class="title title-1"> <div><input disabled autocomplete="false" tabindex="0" min="0" type="number" v-model="item.unitPrice" class="border border-blue-600 py-2 text-xs px-2 outline-none block h-full w-full"/></div></div></div>
                                    <div class="x8yj6t5"><div class="title title-1 justify-center">{{ item.unitPrice * item.quantity }} </div></div>
                                    <div class="x8yj6t5"><div class="title title-1 justify-center"><div class="flex justify-center"><button @click="removeProduct(item, index)" :class="$colors.actionTable" class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1"><i class="material-icons mx-1">delete</i></button></div></div></div>
                                </div>
                                <div class="header-tabl app-theme"><div class="w-full"><div class="title title-1 pt-2"><button @click="EditOrder('products')" id="invoice-item-add" title="Add Item" class="btn btn-prime"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus fa-w-14 "><path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg></button></div></div></div>
                             </div>
                        </div>  
                    </div>
                    <div class="p-4 flex space-x-4 modal-footer">
                        <a href="#" @click="CloseModal('EditOrder')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm" :class="loading?'noselect':''">Annuler</a>
                        <a href="#" @click="EditOrder('edit')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm relative loidingconfirm" :class="loading?'noselect':''"><loading :active.sync="loading" :is-full-page="fullPage"></loading> Confirm update</a>
                    </div>
                </div>
            </vue-modal-2>     
            <vue-modal-2 class="moukhtar"  name="ModalProducts" :headerOptions="{title: 'Add Products'}" :noFooter="true" modalSize="lg" @on-close="CloseModal('ModalProducts')">
                <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
                  <!-- Header -->
                  <div class="flex w-full h-auto justify-center items-center">
                    <div
                      class="flex w-full h-auto py-3 justify-center items-center text-2xl font-bold"
                    >
                      <span
                        class="w-screen md:w-full h-10 cursor-pointer border border-gray-500 rounded text-sm flex"
                      >
                        <input
                          type="search"
                          name="search"
                          v-model="searchText"
                          placeholder="Search"
                          class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none"
                        />
                        <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4"
                          >search</i
                        >
                      </span>
                    </div>
                  </div>
                    <div v-if="products.length <= 0" class="py-2">
                      <span
                        class="w-full flex justify-center text-center py-20 border-b border-gray-500 text-base"
                      >
                        <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                          <span class="">No Products found </span>
                        </p>
                      </span>
                    </div>
                    <table class="table table-report sm:mt-2 table-p">
                        <tr class="intro-x" v-for="(item, index) in resultSearchUsers"  :key="index" :value="item._id">
                          <td class="w-10 border-b border-t border-l border-gray-500"><input type="checkbox" class="form-checkbox order h-5 w-5 text-blue-500 border-gray-500" @change="addProductsToTemp(item)" v-model="item.check"/></td>
                          <td class="w-10 border-b border-t border-gray-500"><div class="flex"><div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden"><img :alt="item.name" :src="item.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"></div></div></td>
                          <td class="border-b border-t border-r border-gray-500"><a href="" class="font-medium whitespace-nowrap">{{ item.name }}</a><div class="text-gray-600 text-xs whitespace-nowrap mt-0.5">{{ exceptDes(item.description) }}</div></td>
                        
                        </tr>
                    </table>  
                </div>

                <div class="modal-footer px-5 border0-t text-right">
                  <button
                    @click="CloseModal('ModalProducts')"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                  Annuler
                  </button>
                  <button
                    @click="EditOrder('addProduct')"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                    Confirm
                  </button>
                </div>
          </vue-modal-2>
          <vue-modal-2 class="moukhtar"  name="ModalDouble" :headerOptions="{title: 'Double orders'}" :noFooter="true" modalSize="xl" @on-close="CloseModal('ModalDouble')">
            <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
                <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg">
                <table class="min-w-full">
                    <thead>
                        <tr>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4  text-blue-600  tracking-wider">ID order</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Customer</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Products</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Total price</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Status</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-right text-sm leading-4  text-blue-600  tracking-wider">Action</th>
                            
                        </tr>
                    </thead>
                        <tbody class="bg-white">
                        <tr v-for="(order,ind) in dataDouble" :key="ind">
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="flex items-center">
                                    <div>
                                        <div class="text-sm leading-5 text-gray-800">{{$f.getIdbySplit(order.id)}}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 siz12 text-blue-900">
                                  <div class="flex-grow-1">
                                    <h5 class="fs-14 mb-1">{{order.customer.fullName}}</h5>
                                    <p class="badge badge-soft-success text-uppercase">{{order.customer.phone}}</p></div>
                                  
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900">{{sumProduct(order.details)}}</div>
                            </td>
                            <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{order.totalPrice}} </div>
                            </td>
                             <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900" v-bind:style="{color: order.status.name?order.status.color:'',borderColor: order.status.name?order.status.color:''}">{{order.status.name}}</div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1 text-right">
                              <router-link target="_blank" :to="{ path: `/orders/detail/${order._id}`}" class="text-sm leading-5 px-2 rounded-full text-xs text-blue-900 cursor-pointer font-medium"><i class="material-icons mx-2"> remove_red_eye</i></router-link>
                            </td>
                           
                        </tr>
                        </tbody> 
                    </table>
                            
            </div>     
                
            </div>

            <div class="modal-footer px-5 border0-t text-right">
                <button @click="CloseModal('ModalDouble')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Annuler</button>
            </div>
          </vue-modal-2>    
        <!-- ___________________________________________________________Debut section PopUp _________________ -->
      </div>
    </div>

    <!-- <div
      v-if="finished && showButtonStart == false"
      class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-3 items-center"
    >
      <div class="bg-white w-full rounded-lg shadow">
        <div class="bg-white w-full rounded-lg shadow">
          <div class="flex justify-center">
            <p></p>
            <p
              class="justify-center font-semibold flex text-blue-500 whitespace-no-wrap"
            >
              <i class="material-icons mx-3">error</i>
              No order To Confirm
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
var Timer = require("easytimer.js").Timer;
var timer = new Timer();
import Cookies from 'js-cookie'
const _= require('lodash')
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String}
   },
  data() {
    return {
      formData: {
        customer: {},
        details: [],
        seller: {},
      },
      zones: [],
      courier: [],
      loading:false,
      loadingeditOrder:false,
      loadinggetorder:false,
      fullPage: false,
      shipping: {
        date: "",
        zone: "",
        courrier: "",
      },
      limit: 1,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      statusOrder: [],
     // currentUser: {},
      order: [{
        customer: {},
        details: [],
        seller: {},
        teleConsultant: {},
        skippedBy: [],
        unreachedBy: [],
      }],
      showButtonStart: true,
      vShow: false,
      orderFound:false,
      finished: false,
      isEditing: false,
      style: false,
      edit: true,
      sec: 0,
      min: 0,
      hr: 0,
      passedTime: "",
      time:0,
      m: 0,
      s: 0,
      h: 0,
      dateDebut: "",
      zeroH: false,
      zeroM: false,
      zeroS: false,
      motifAnnulation: "",
      nowDate:"",
     // idWharhouse:null,
      motifUnrached:"",
      commentsUnrach:["A rappeler","Boite vocale","Ne répond pas","Hors ligne"],
      products:[],
      searchText: "",
      numberItemRepeated: 0,
      productselected: [],
      checkOutOfstock:{action:false,message:"",type:'normal',stock:0},
      loadingDouble:false,
      dataDouble:[],
      remindDate:null,
      contentRemend:"",
      checkWarehousingParent:[],
    };
  },
  computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
    }, 
  watch: { 
    // "$store.state.wharhouse.warhouseSelected": {
    //   async handler(newValue, oldValue) {
    //           await this.getwharhouseId();
    //           await this.getZones();
    //         },
    //         deep: true
    // },
    'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getZones();  
            await this.CheckWarehouseParent();
            console.log('idWharhouse change country--------',this.idWharhouse.country)
      }
   },
  async mounted() {
    this.token = this.$jwtService.verifyToken();
    console.log('idWharhouse country--------',this.idWharhouse.country)
    console.log('sous_idWharhouse _id--------',this.sous_idWharhouse)
   // await this.getUser();
   // await this.getwharhouseId();
    await this.getStatus();
    await this.CheckWarehouseParent();
    await this.getZones();
    const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
    this.nowDate=new Date(nDate);
    // if(this.currentUser.type != "TeleConsultant" && this.currentUser.type != "NRP"){
    //   console.log('nnon telec',this.currentUser.type)
    //       this.$router.push({ name: 'Home' })
    // }
  },
  computed: {
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter((product) => {
          var regex = new RegExp(this.searchText, "i");

          return regex.test(product.name);
        });
      } else {
        return this.products;
      }
    },
  },
  methods: {
    validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  },
    async CloseModal(id){
      this.$vm2.close(id);
      if(id == 'EditOrder'){
        this.loadingeditOrder=true;
        delete this.order.EditOrder;
        const orderCheck=await this.$server.get("orders",{  _id: this.order._id,PopulateProductOnly:true } );
        this.loadingeditOrder=false;
        if(orderCheck.content && orderCheck.content.details) this.order.details=orderCheck.content.details;
      }
    },
    async CheckWarehouseParent(){
      const resW = await this.$server.search("warehouses", { country: this.idWharhouse.country,all:true,limit:100}); 
      console.log('resW--------------',resW)
      if(resW.content && resW.content.results) this.checkWarehousingParent=resW.content.results;
      else this.checkWarehousingParent=[];
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    TotalPrice(){
      let Total=0;
      if(this.order && this.order._id){
        for (const element of this.order.details) {
            Total+=element.unitPrice * element.quantity;
        }
        this.order.totalPrice=Total;
      }
        return Total;
     },
    async EditOrder(action){
      if(action == 'open') {
        this.$vm2.open('EditOrder');
        this.products=[];
      }
      if(action == 'products'){
        await this.getProducts({});
        if (this.products.length > 0) {
            this.$vm2.open("ModalProducts");
        } else alert(`There are no products for the selected seller`, "warning");
      }
      if(action == 'addProduct'){
        let fount = 0;
        for (let i = 0; i < this.productselected.length; i++) {
          this.order.details.push(this.productselected[i]);
        }
        this.productselected = [];
        if (this.numberItemRepeated > 0) {
          alert(`There are many products already added!`, "success");
        }
        this.numberItemRepeated = 0;
        this.$vm2.close("ModalProducts");
      }
      if(action == 'edit'){
        if(this.order.details.length<=0){
          alert(`Cette order ne contient aucun produit !`, "warning");
          return false;
        }else{
          this.loading=true;
          this.order.EditOrder=true;
          const OrderEdi = await this.$server.update("orders", _.pick(this.order, ['_id', 'details','totalPrice','EditOrder']));
          this.loading=false;
          console.log('oooooooooooooooooook 222222222',OrderEdi)
          if(OrderEdi && OrderEdi._id){
            alert(`Order updated`, "success");
            this.$vm2.close("EditOrder");
            delete  this.order.EditOrder;
          }else  alert(OrderEdi.message_1||OrderEdi, "warning");
        }
      }
    },
    addQuantity(index) {
      this.order.details[index].quantity++;
    },
    removeQuantity(index) {
      if (this.order.details[index].quantity <= 1) {
      } else this.order.details[index].quantity--;
    },
    async getProducts() {
      if (this.order.seller && this.order.warehouse) {
        const filters = {
          seller: this.order.seller._id||this.order.seller,
          warehouse:this.order.warehouse._id||this.order.warehouse,
          limit:3000
        };
        const res = await this.$server.search("products", filters);
      
        if (res && res.content) {
          this.products = res.content;
          for (let i in this.products) {
            this.products[i].quantity = this.products[i].details[0].quantity.inStock;
            this.products[i].price = this.products[i].details[0].price;
            this.products[i].seller = this.products[i].seller;
          }
        } else this.products = [];
      }else  alert("You must select a seller", "warning");
    },
    addProductsToTemp(data) {
      if(data.check) {
        const detail = {product: data,unitPrice: data.price,quantity: 1,};
        let found = 0;
        for (let i = 0; i < this.order.details.length; i++) {
          if (this.order.details[i].product._id == data._id) {
            found = found + 1;
            this.numberItemRepeated = this.numberItemRepeated + 1;
          }
        }
        if (found >= 1) {
        } else this.productselected.push(detail);
      }else{
        let pos = this.productselected.map(function (e) {return e.product._id;}).indexOf(data._id);
        this.productselected.splice(pos, 1);
      }
    },
    removeProduct(data, index) {
      if(this.order.details.length==1){
        alert(`Tu peux pas supprimer cette produit please ajouter un autre produit puis essayé !`, "warning");
        return false;
      }
      this.$confirm("Are you sure you want to delete this product?").then(
        async (res) => {
           var index = this.order.details.findIndex(function(o){return o.product._id === data.product._id;})
           if (index !== -1) this.order.details.splice(index, 1);
          data.product.check = false;
          alert(`Product deleted !`, "success");
        }
      );
    },
    exceptDes(text){
      if (text && text.length > 60) text = text.substring(0, 60) + "...";
      return text;
    },
    async getZones() {
        const res = await this.$server.search("zones",{ limit: 10,warehouse:this.idWharhouse._id});
        if (res && res.content.results) this.zones = res.content.results;
        else this.zones = [];
    },
    serchZones: _.debounce(async function(name,type) {
       console.log('event______________',name)
          await this.$store.dispatch('wharhouse/searchUser',{type: 'zone',warhouse:this.idWharhouse._id,search:name}).then((res) => {
            this.zones = res
          })
   }, 500), 
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.$store.getters["wharhouse/warhouseSelected"](this.currentUser),}).then((res) => {this.idWharhouse=res;})
    }, 
    async getStatusByName(name) {
        const result = await this.$server.get("status",{  name: name  });
        return result.content;
    },
    dateMin(){ 
      //document.getElementById('shippdate').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
    },
    CalculateTime() {
      // this.passedTime =this.hr + "hr " + ":" + this.min + " min" + ": " + this.sec + "sec";
      // this.time=this.hr*3600 +  this.min*60 + this.sec;
      // clearTimeout(this.h);
      // clearTimeout(this.m);
      // clearTimeout(this.s);
      this.passedTime=timer.getTimeValues().toString();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async assign(data) {
      //if (!data.teleConsultant) {
        data.teleConsultant = this.currentUser._id;
        data.startDate=this.$moment(new Date()).format('yyyy-MM-DD HH:mm');
        data.updateStartDate=true;
        data.updateTeleConsultant=true;
        await this.$server.update("orders", data);
        delete data.updateTeleConsultant;
      //}
    },
    async SetStatus(){
      if(!Cookies.get('Pending')){
          const s_id1 = await this.getStatusByName("Pending");
          Cookies.set('Pending', JSON.stringify(s_id1), { expires: 30 })
       }
       if(!Cookies.get('Waiting')){
         const s_id2 = await this.getStatusByName("Waiting");
          Cookies.set('Waiting', JSON.stringify(s_id2), { expires: 30 })
       }
       if(!Cookies.get('Unreached')){
         const s_id3 = await this.getStatusByName("Unreached");
          Cookies.set('Unreached', JSON.stringify(s_id3), { expires: 30 })
       }
       if(!Cookies.get('Confirmed')){
         const s_id4 = await this.getStatusByName("Confirmed");
          Cookies.set('Confirmed', JSON.stringify(s_id4), { expires: 30 })
       }
       if(!Cookies.get('Cancelled')){
         const s_id5 = await this.getStatusByName("Cancelled");
          Cookies.set('Cancelled', JSON.stringify(s_id5), { expires: 30 })
       } 
    },
    async getOrderDoubled(phone,seller,product,id){
      this.loadingDouble=true;
      const data = await this.$server.search("orders",{'details.product':product,warehouse:this.idWharhouse._id,phone:phone,_id:id,seller:seller,limit:100});
      this.loadingDouble=false;
      if(data && data.content && data.content.results) this.dataDouble=data.content.results;
      else this.dataDouble=[]
      console.log('data-------',data)
    },
    async RemindOrder(dataToEdit){
      this.loading=true;
      dataToEdit.comment=this.contentRemend;
      if (!this.remindDate) {
        alert('Reminded date required !', "warning");
        this.loading=false;
        return false;
      }
      dataToEdit.oldStatus = dataToEdit.status._id||dataToEdit.status;
      dataToEdit.remind=this.$moment(this.remindDate).format('yyyy-MM-DD HH:mm');
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.teleConsultant = null;
      dataToEdit.reminded = true;
      dataToEdit.lastUnreachedDate = null;
      
      
       console.log('date____', dataToEdit);
       //return false
       dataToEdit.idWharhouse = this.idWharhouse;
      const data = await this.$server.update("orders", dataToEdit);
      this.loading=false;
      if (data && data._id) {
        this.refreshData("Order reminded", "success"); 
      }else{
       // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
        this.showButtonStart = true;
         this.vShow = true;
         this.contentRemend="";
         this.remindDate=null;
         this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        alert(data, "warning");
      }
    },
    async startConfirmation() {
      this.checkOutOfstock={action:false,message:"",type:'normal',stock:0};

      await this.getOrder();
      

      if (this.orderFound) {
        await this.assign(this.order);
        timer.reset();
        timer.start();

        timer.addEventListener('secondsUpdated', function (e) {
            $('#gettingValuesExample .hours').html(('0' + timer.getTimeValues().hours).slice(-2));
            $('#gettingValuesExample .minutes').html(('0' + timer.getTimeValues().minutes).slice(-2));
            $('#gettingValuesExample .seconds').html(('0' + timer.getTimeValues().seconds).slice(-2));
        });

         document.body.style.overflow = 'inherit'

        this.showButtonStart = false;
        this.sec = 0;
        this.min = 0;
        this.hr = 0;
        const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
        let newdate=new Date(nDate)
        this.dateDebut =this.$moment(new Date()).format('yyyy-MM-DD HH:mm');
       // await this.getOrderDoubled(this.order.customer.phone,this.order.seller._id,this.order.details[0].product._id,this.order._id);
       
      } else {
        alert("No Order To confirm", "warning");
      }
    },
    async getOrder() {
      if(!this.idWharhouse){
         alert("No warehouse found", "warning");
         return false;
      }
      this.loadinggetorder=true;
      console.log('warhouse',this.idWharhouse.country)
      const data = await this.$server.confirmation("orders",{warehouse:this.idWharhouse._id});
      this.loadinggetorder=false;
      console.log('dat____________',data)
      if (data && data.status==200) {
        this.orderFound=true;
        this.order = data.content;
        this.order.date=this.$moment(this.order.date).format('yyyy-MM-DD');
      } else {
        this.order=[{
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
      }],
        this.orderFound=false;
        this.finished = true;
      }
    },
    //****************************** Zones  ***********************************/
    async getCourierZone(zone) {
      console.log('zone____',zone)
      if(zone){
        const filter = {
          type: "Courier",
          zones: zone._id,
          limit:1000
        };
        const res = await this.$server.search("users", filter);
        console.log("HII JE SUIS res soukaina", res);
        if (res && res.content.results) {
          this.courier = res.content.results;
        } else this.courier = [];
      }
    },
    // **************************************************************************
    async getStatus() {
      const res = await this.$server.search("status");
      if (res && res.content.results) this.statusOrder = res.content.results;
      else this.statusOrder = [];
    },
    getStatusId(status) {
      for (let i in this.statusOrder) {
        if (this.statusOrder[i].name == status) {
          return this.statusOrder[i]._id;
        }
      }
    },

    CreateShipping() {
      const data = {
        address: this.order.customer.shippingAddress,
        date: this.shipping.date,
        order: this.order._id,
        zone: this.shipping.zone._id,
        courrier: this.shipping.courrier._id,
      };
      console.log("HIIIIIIIIIIIIIIII SE SUIS data", data);
      // const data = await this.$server.create("status", this.formData);
    },

    async ConfirmOrderStatus(dataToEdit) {
     this.loading=true;
    // console.time('ConfirmOrderStatus');
    // await this.SetStatus();

      this.dateMin();
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.teleConsultantConfirm = this.currentUser;
     
     //console.log('warhouse________________',this.order)
      if (
        this.shipping.date &&
        this.order.customer.shippingAddress &&
        this.order.warehouse &&
        this.order._id
      ) {
         const datashipping = {
          address: this.order.customer.shippingAddress,
          date: this.$moment(this.shipping.date).format('yyyy-MM-DD'),
         // order: this.order._id,
         // seller: this.order.seller,
         // warehouse: this.order.warehouse,
          status: "queued",
      };
      if(this.shipping.courrier){
        datashipping.courier=this.shipping.courrier;
      }
      if(this.shipping.zone){
        datashipping.zone=this.shipping.zone;
        dataToEdit.zone=this.shipping.zone;
      }
      if((this.idWharhouse.country=='CI' || this.checkWarehousingParent.length>1) && !this.shipping.zone){
         this.loading=false;
         alert("Zone required !", "warning");
         return false;
      }

        dataToEdit.shipping = datashipping;
        console.log('dataToEdit 1111111',dataToEdit.shipping)
        //console.log('oooooooooooooooooook 1111111')
        delete dataToEdit.seller;
        dataToEdit.Confirmation=true;
        dataToEdit.country=this.idWharhouse.country;
        dataToEdit.countryName=this.idWharhouse.name;
        let dataOrr = await this.$server.update("orders", dataToEdit);
        //console.timeEnd('ConfirmOrderStatus');
        this.loading=false;
         console.log('oooooooooooooooooook 222222222',dataOrr)
        if(dataOrr && dataOrr._id){
          alert("Order Confirmed", "success");
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
          };
          this.shipping={}
          this.showButtonStart = true;
          this.vShow = true;
        }else {
           let BodyDataOrder={_id: this.order._id,teleConsultant:null};
           if(dataOrr.message_1 && dataOrr.action && dataOrr.action=='Confirmation'){
              BodyDataOrder.warehouse=dataOrr.warehouse;
              BodyDataOrder.productId=dataOrr.productId;
              BodyDataOrder.ChangeToWaiting=true;
              BodyDataOrder.quantity=dataOrr.quantity;
              await this.$server.update("orders", BodyDataOrder); 
           } 
           
            this.showButtonStart = true;
            this.vShow = true;
            this.order = {
              customer: {},
              details: [],
              seller: {},
              teleConsultant: {},
              skippedBy: [],
            };
            this.shipping={};
            console.log('dataOrr -----------------',dataOrr)
            alert(dataOrr.message_1||dataOrr, "warning");
          }
      } else {
        this.loading=false;
        alert("You must fill all required field", "warning");
      }
    },
    async OrangeOrderStatus(dataToEdit,name) {

      this.$confirm(`Etes-vous sûr de changer la commande en: ${name} ?`).then(async (res) => {
         if (res) {
           this.loading=true;
           let id = await this.getStatusByName(name);
           dataToEdit.status = id;
           dataToEdit.statusCallcenter = id;
           this.CalculateTime();
           dataToEdit.timeConsumed = this.passedTime;
           dataToEdit.time = parseInt(this.time);
           dataToEdit.dateDebut = this.dateDebut;
          // dataToEdit.teleConsultantConfirm = this.currentUser._id;
           dataToEdit[name.replace(/\s/g, '')] = true;
           dataToEdit.comment='';
           const data = await this.$server.update("orders", dataToEdit);
           this.loading=false;
           if (data && data._id) {
              this.refreshData('Order updated', "success")
           }else{
           // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
              alert(data,"warning");
               this.motifUnrached="";
              this.motifAnnulation="";
              this.showButtonStart = true;
              this.vShow = true;
                this.order = {
                  customer: {},
                  details: [],
                  seller: {},
                  teleConsultant: {},
                  skippedBy: [],
                  unreachedBy: [],
                };
                this.shipping={}
            }

          }
       });
      
   },
    async skipOrder(dataToEdit) {

      if(this.checkOutOfstock.action){
         this.loading=false;
        // const dataOr = await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
         this.showButtonStart = true;
         this.vShow = true;
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
          };
          this.shipping={}
         return false;
      }

      // let id =  await this.getStatusByName("Skipped");
      // const element = {
      //   user: this.currentUser._id,
      // };

      // dataToEdit.skippedBy.push(element);
      // dataToEdit.skiped = id;
      // dataToEdit.teleConsultant = null;

      // this.$confirm("You want to skip this order?").then(async (res) => {
      //   if (res) {
      //     this.CalculateTime();
      //     dataToEdit.timeConsumed = this.passedTime;
      //     dataToEdit.time = parseInt(this.time);
      //      dataToEdit.teleConsultantConfirm = this.currentUser;
      //     dataToEdit.dateDebut = this.dateDebut;
         
      //     const data = await this.$server.update("orders", dataToEdit);
      //     if (data._id) {
      //       alert("Order skipped", "warning");
      //       this.order = {
      //         customer: {},
      //         details: [],
      //         seller: {},
      //         teleConsultant: {},
      //         skippedBy: [],
      //         unreachedBy: [],
      //       };
      //       this.showButtonStart = true;
      //       this.vShow = true;
      //     }
      //   }
      // });
    },
    /************************************************* */
    async cancelOrder(dataToEdit) {
      if(this.motifAnnulation) this.motifAnnulation=this.motifAnnulation.toString().trim();
      if(!this.motifAnnulation){
          alert('Reason for cancellation required', "warning");
          return false
      }
      this.loading=true;
      dataToEdit.motifAnnulation = this.motifAnnulation;
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.teleConsultantConfirm = this.currentUser;
      dataToEdit.dateDebut = this.dateDebut;

      dataToEdit.comment=this.motifAnnulation;

      dataToEdit.cancelOrder=true;
      const data = await this.$server.update("orders", dataToEdit);
      //console.timeEnd('cancelOrder');
      this.loading=false;
      if (data && data._id) {
        this.showButtonStart = true;
        this.vShow = true;
        this.motifAnnulation="";
        alert("Order cancelled", "success");
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
      }else{
       // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
         this.showButtonStart = true;
         this.vShow = true;
         this.motifAnnulation="";
         this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        alert(data, "error");
      }
    },

    /************************************************************/

    async UnreachedOrder(dataToEdit) {
      this.loading=true;
      //console.time('UnreachedOrder');
      const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
      let newdate=new Date(nDate);
      dataToEdit.oldStatus = dataToEdit.status._id||dataToEdit.status;
        
      dataToEdit.teleConsultant = null;
      dataToEdit.lastUnreachedDate = newdate;
    
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.dateUnrash = newdate;
      dataToEdit.comment=this.motifUnrached;
      if(dataToEdit.remind){
        dataToEdit.remind=null;
        dataToEdit.isReminded=false;
      }
      
      
      delete dataToEdit.updateStartDate;

          //check order teleconsulatnt
          const orderCheck = await this.$server.get("orders",{  _id: this.order._id,PopulateProductOnly:true } );
          if(!this.motifUnrached){
             alert('Reason unreached required', "warning");
             this.loading=false;
             return false
          }
          const element = {
            user: this.currentUser._id,
            date: orderCheck.content.startDate
          };
          dataToEdit.unreachedBy.push(element);
          dataToEdit.pending_unrached = true;
          dataToEdit.lastUnreachedDate = orderCheck.content.startDate;

          console.log('ooook unrached')
          const data = await this.$server.update("orders", dataToEdit);
          console.timeEnd('UnreachedOrder');
          this.loading=false;
          if (data && data._id) {
              this.refreshData("Order unreached", "success"); 
          }else{
           // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
            alert(data,"warning");
            this.motifUnrached="";
            this.motifAnnulation="";
              this.showButtonStart = true;
              this.vShow = true;
                this.order = {
                  customer: {},
                  details: [],
                  seller: {},
                  teleConsultant: {},
                  skippedBy: [],
                  unreachedBy: [],
                };
                this.shipping={}
            }
      //   }
      // });
    },
    /****************** Edit Information **********************/
    activateInEditMode() {
      this.isEditing = true;
      this.edit = false;
      this.style = true;
    },
    refreshData(message,type){
       alert(message,type);
       this.motifUnrached="";
       this.motifAnnulation="";
       this.remindDate=null;
       this.contentRemend="";
        this.showButtonStart = true;
         this.vShow = true;
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
            unreachedBy: [],
          };
          this.shipping={}
    },
    async updateData(dataToEdit) {
      this.$confirm("You want really to update information ?").then(
        async (res) => {
          if (res) {
            const data = await this.$server.update("orders", dataToEdit);
            if (data._id) {
              this.isEditing = false;
              this.style = false;
              this.edit = true;
              alert("updated", "success");
            }
          }
        }
      );
    },
    async desactivateInResetMode() {
      this.isEditing = false;
      this.style = false;
      this.edit = true;
      await this.getOrder();
    },

    ChronoStart() {
      // if (this.sec < 60) {
      //   this.s = setTimeout(() => {
      //     this.sec += 1;
      //     this.ChronoStart();
      //   }, 1000);
      //   this.remettreAZero();
      // } else if (this.min == 60) {
      //   this.hr += 1;
      //   this.min = 0;
      //   this.h = setTimeout(() => {
      //     this.sec += 1;
      //     this.ChronoStart();
      //   }, 1000);
      //   this.remettreAZero();
      // } else {
      //   this.min += 1;
      //   this.sec = 0;
      //   this.m = setTimeout(() => {
      //     this.sec += 1;
      //     this.ChronoStart();
      //   }, 1000);
      //   this.remettreAZero();
      // }

      if (this.min==0) {this.min='00'}
      if(this.hr==0) {this.hr='00'}
      this.sec++;
      if (this.sec<10){this.sec='0'+this.sec;}
      if (this.hr==24){this.hr='0'+0;}
      if (this.sec==60){this.sec=0; this.min++;if(this.min<10){this.min='0'+this.min;}}
      if (this.min==60){this.min='0'+0;this.hr++;if(this.hr<10){this.hr='0'+this.hr;}}
     setTimeout(() => this.ChronoStart() , 1000);
    },

    remettreAZero() {
      if (this.sec < 10) {
        this.zeroS = true;
      } else {
        this.zeroS = false;
      }
      if (this.min < 10) {
        this.zeroM = true;
      } else {
        this.zeroM = false;
      }
      if (this.hr < 10) {
        this.zeroH = true;
      } else {
        this.zeroH = false;
      }
    },
  },
};
</script>


<style scoped>


.bg-depot{
  background-color: #df24cb;
}
.btn-action {
    -webkit-animation: shadow-pulse 1s infinite;
    animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse{ 
    0%{box-shadow:0 0 0 0px rgba(30, 112, 185);}
    100%{box-shadow:0 0 0 15px rgba(0, 0, 0, 0);}
}
.mx-datepicker{
  width: 100%;
  padding: 6px 8px;
}
.wrap-1{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button-2 {
  min-width: 300px;
min-height: 60px;
font-family: 'Nunito', sans-serif;
font-size: 22px;
text-transform: uppercase;
letter-spacing: 1.3px;
font-weight: 700;
background: linear-gradient(90deg, rgb(113, 159, 236) 0%, rgb(66, 133, 244) 100%);
border: none;
border-radius: 1000px;
box-shadow: 12px 12px 24px rgba(103, 157, 247, 0.53);
transition: all 0.3s ease-in-out 0s;
cursor: pointer;
outline: none;
position: relative;
padding: 10px;
color: #fff;
  }

 .button-2::before {
  content: '';
  border-radius: 1000px;
  min-width: calc(300px + 12px);
  min-height: calc(60px + 12px);
  border: 6px solid #00FFCB;
  box-shadow: 0 0 60px rgba(0,255,203,.64);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all .3s ease-in-out 0s;
}

.button-2:hover, .button-2:focus {
  color: #fff;
  transform: translateY(-6px);
}

.button-2:hover::before, .button-2:focus::before {
  opacity: 1;
}

.button-2::after {
  content: '';
  width: 30px; height: 30px;
  border-radius: 100%;
  border: 6px solid #00FFCB;
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ring 1.5s infinite;
}

.button-2:hover::after, .button-2:focus::after {
  animation: none;
  display: none;
}

@keyframes ring {
  0% {
    width: 30px;
    height: 30px;
    opacity: 1;
  }
  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}

.bg-imgg:before{
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.2;
  background: url("https://storeno.b-cdn.net/shipsen/11-2022/1669062344861.jpeg") no-repeat center center;
  background-size: auto;
  background-size: cover;
}
.phone{
  background-color: #e8bc52;
  border-color: #e8bc52;
  color: #fff !important;
  display: inline-block;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  padding: 2px;
}
.box-3{
  /* background-image: linear-gradient( 117deg,  rgba(123,216,96,1) 39.2%, rgba(255,255,255,1) 156.2% ); */
  /* background-image: linear-gradient( 180.5deg,  rgba(46,255,171,1) 12.3%, rgba(252,251,222,0.46) 92% ); */
  background-image: linear-gradient( 109.6deg,  rgba(223,234,247,1) 11.2%, rgba(244,248,252,1) 91.1% );
}
.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}
.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}
.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.badge-soft-success {
  color: #e8bc52;
background-color: rgba(232,188,82,.1);
display: inline-block;
padding: 2px 2px;
font-size: 14px;
font-weight: 500;
line-height: 1;
text-align: center;
white-space: nowrap;
vertical-align: baseline;
border-radius: 10px;
}
.card-2{
  margin-bottom: 1.1rem;
  -webkit-box-shadow: 0 1px 2px rgba(56,65,74,.15);
  box-shadow: 0 1px 2px rgba(56,65,74,.15);
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-image: linear-gradient( 181.2deg,  rgba(181,239,249,1) 10.5%, rgba(254,254,254,1) 86.8% );
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 0.25rem;
}
.card-header-1:first-child {
  border-radius: 0.25rem 0.25rem 0 0;
}
.card-header-1 {
  border-bottom: 1px solid #e9ebec;
}
.card-header-1 {
  padding: 1rem 1rem;
  margin-bottom: 0;
  background-color: #fff;
}
.card-title {
  font-size: 17px;
  margin: 0 0 7px 0;
    margin-bottom: 7px;
}
h5 {
  font-weight: 600;
  line-height: 1.2;
}
.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important;
}
@-moz-keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
@-webkit-keyframes facebookSpinner {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
@keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.7, 0.7);
    -ms-transform: scale(0.7, 0.7);
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
.facebook-spinner {
  width: 25px;
  height: 28px;
  display: inline-block;
  vertical-align: middle;
}
.facebook-spinner .spinner-block {
  float: left;
  width: 7px;
  height: 28px;
  background-color: #8b9dc3;
  border: 1px solid #3b5998;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-animation-name: facebookSpinner;
  -webkit-animation-name: facebookSpinner;
  animation-name: facebookSpinner;
  -moz-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -moz-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.facebook-spinner .spinner-block:not(:last-child) {
  margin-right: 2px;
}
.facebook-spinner .block-1 {
  -moz-animation-delay: 100ms;
  -webkit-animation-delay: 100ms;
  animation-delay: 100ms;
}
.facebook-spinner .block-2 {
  -moz-animation-delay: 200ms;
  -webkit-animation-delay: 200ms;
  animation-delay: 200ms;
}
.facebook-spinner .block-3 {
  -moz-animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
  animation-delay: 300ms;
}


.me-1 {
  margin-right: .25rem !important;
}
.align-middle {
  vertical-align: middle !important;
}
.card-body-2 {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem 1rem;
}
  .card-body-1 {
    flex: 1 1 auto;
    min-height: 1px;
}
.bg-light-primary {
  background-color: #0bc1f712;
  border-color: #3182ce;
}
.bg-blue-box{
  background: linear-gradient(112.14deg, #00D2FF 0%, #3A7BD5 100%);
  color: white;
}
.card-1 {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
.header-table.th-header{
  background-color: #d4ebff;
}
.header-1 .content{
  height: inherit !important;
  }
.header-table{
  padding-left: 5px;
}
.x8yj6t5 {
  width: 10% !important;
}
.x8yj6t55{
  width: 15%;
}
.quant{
  margin: 0 !important;
}
.vm2_wrapper{
  z-index: 11;
}
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
.v-select{
  width: 100%;
}
.vs__dropdown-toggle {
    border: none;
}
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.label {
  transition: all 0.2s ease-out;
  top: 0.4rem;
  left: 0;
}
.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;
}

.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;
  
  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}

.flip-clock__slot {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
}

.flip-card {
  display: block;
  position: relative;
  padding-bottom: 0.1em;
  font-size: 2.25rem;
  line-height: 0.95;
}

@media (min-width: 1000px) {
  .flip-clock__slot { font-size: 1.2rem; }
  .flip-card { font-size: 3rem; }
}


/*////////////////////////////////////////*/


.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: 1.44em;
  color: #ccc;
  background: #222;
  padding: 0.23em 0.25em 0.4em;
  border-radius: 0.15em 0.15em 0.15em 0.15em;
  backface-visiblity: hidden;
  transform-style: preserve-3d;
  width: 1.8em;
}

.flip-card__bottom,
.flip-card__back-bottom {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 0.15em 0.15em;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}

.flip-card__back-bottom {
  z-index: 1;
}

.flip-card__bottom::after,
.flip-card__back-bottom::after {
  display: block;
  margin-top: -0.72em;
}

.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after {
  content: attr(data-value);
}

.flip-card__back {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}

.flip-card__back::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.flip .flip-card__back::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(.37,.01,.94,.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}

.flip .flip-card__bottom {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(.15,.45,.28,1);
}
.icon-call{
  font-size: 40px;
}
@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%, 99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}

@keyframes flipBottom {
  0%, 50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
</style>


